<script setup>
import { ref, computed } from 'vue'
import { debounce } from '@/js/helper';

// props
const props = defineProps({
  type: {
    type: String,
    default: ''
  },
  target:{
    type: String,
    default: ''
  },
  active:{
    type: Boolean,
    default : false
  }
})

// data - ref
const button = ref(null)

// expose
defineExpose({
  button
})

// computed
const getAttr = computed(() => {
  switch(props.type) {
    case 'login': {
      return {
        class: 'btn btn-primary btn-login'
      }
    }
    case 'search': {
      return {
        class: 'btn btn-primary btn-search',
      }
    }
    case 'modelHeaderClose': {
      return {
        class: 'btn btn-close',
        'data-bs-dismiss': 'modal',
        'aria-label': 'Close'
      }
    }
    case 'modelFooterConfirm': {
      return {
        class: 'btn btn-primary btn-sm',
      }
    }
    case 'modelFooterClose': {
      return {
        class: 'btn btn-secondary btn-sm',
        'data-bs-dismiss': 'modal',
      }
    }
    case 'primary': {
      return {
        class: 'btn btn-primary',
      }
    }
    case 'primary w-100': {
      return {
        class: 'btn btn-primary w-100',
      }
    }
    case 'excelDownload': {
      return {
        class: 'btn table-btn-group-excel',
      }
    }
    case 'codeRegist': {
      return {
        class: 'btn btn-sm btn-code',
      }
    }
    case 'codeRegistActive': {
      return {
        class: 'btn btn-sm btn-code active',
      }
    }
    case 'accordionHeader': {
      return {
        class: props.active ? 'accordion-button accordion-button-register' :'accordion-button accordion-button-register collapsed',
        'data-bs-toggle': 'collapse',
        'data-bs-target': '#'+props.target,
        'aria-expanded': false,
        'aria-controls': props.target,
      }
    }
    case 'sideBtnActive': {
      return {
        class: 'accordion-button accordion-icon-normal',
      }
    }
    case 'sideBtnNonActive': {
      return {
        class: 'accordion-button accordion-icon-normal collapsed',
      }
    }
    case 'accordionSide': {
      return {
        class: props.active ? 'accordion-button':'accordion-button collapsed',
        'data-bs-toggle': 'collapse',
        'data-bs-target': '#' +props.target,
        'aria-expanded': true,
        'aria-controls': props.target,
      }
    }
    case 'sch-sm-btn': {
      return {
        class: 'btn btn-sm btn-code',
        icon: 'ic-sch'
      }
    }
    case 'btn-s-tb': {
      return {
        class: 'btn btn-sm btn-s-tb',
      }
    }
    case 'dropdown': {
      return {
        class: 'form-select text-start',
        type: 'button',
        'data-bs-toggle': 'dropdown',
        'aria-expanded': false,
      }
    }
    case 'share': {
      return {
        class: 'btn table-btn-group-email',
      }
    }
    case 'clear': {
      return {
        class: 'btn table-btn-group-clear',
      }
    }
    case 'trashCan': {
      return {
        class: 'btn btn-sm btn-s-clear',
      }
    }
    case 'capture': {
      return {
        class: 'btn table-btn-group-capture',
      }
    }
    case 'registPhoto': {
      return {
        class: 'btn btn-sm btn-photo',
      }
    }
    case 's-search': {
      return {
        class: 'btn btn-sm btn-s-search'
      }
    }
    case 'list': {
      return {
        class: 'btn table-btn-group-list'
      }
    }
    case 'stage': {
      return {
        class: 'btn table-btn-group-stage'
      }
    }
    case 'fileDel': {
      return {
        class: 'btn btn-del'
      }
    }
    case 'autoPrimary': {
      return {
        class: 'ml-auto btn btn-primary'
      }
    }
    case 'hamburger': {
      return {
        class: 'nav-top-allmenu',
        'data-bs-toggle': 'offcanvas',
        'data-bs-target': '#' +props.target,
        'aria-expanded': false,
        'aria-controls': props.target,
      }
    }
    case 'hamburgerM': {
      return {
        class: 'nav-m-allmenu',
        'data-bs-toggle': 'offcanvas',
        'data-bs-target': '#' +props.target,
        'aria-expanded': false,
        'aria-controls': props.target,
      }
    }
    case 'headerClose': {
      return {
        class: 'btn-close',
        'data-bs-dismiss': 'offcanvas',
        'aria-label':"Close"
      }
    }
    case 'bookmarkL': {
      return {
        class:  props.active ? 'btn btn-sm btn-favorite active' : 'btn btn-sm btn-favorite', 
        'data-bs-toggle':"button",
        'aria-pressed':true
      }
    }
    case 'bookmarkS': {
      return {
        class: props.active ? 'btn btn-sm btn-favorite-s active' : 'btn btn-sm btn-favorite-s',
        'data-bs-toggle':"button",
        'aria-pressed':false
      }
    }
    case 'formSelect' :{
      return{
        class : 'form-select text-start show',
        'data-bs-toggle' : "dropdown",
        'aria-expanded' : true
      }
    }
    case 'detailBtn' :{
      return{
        class : 'accordion-button collapsed btn-detail',
        'data-bs-toggle' : "collapse",
        'data-bs-target' : '#'+props.target
      }
    }
  }
  return []
})

// emit
const emit = defineEmits(['buttonClick'])

// methods
function emitClick() {
  emit('buttonClick')
}
const debounceEmitClick = debounce(emitClick)
</script>

<template>
  <button ref="button" type="button" v-bind="getAttr" @click="debounceEmitClick">
    <slot></slot>
  </button>
</template>